import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// ── MacroMatrix (main site) ────────────────────────────────────────────────
const firebaseConfig = {
  apiKey: "AIzaSyDcY4MaKtwtPbLniCuS63vKOjbgt345VkY",
  authDomain: "macro-matrix-web.firebaseapp.com",
  projectId: "macro-matrix-web",
  storageBucket: "macro-matrix-web.appspot.com",
  messagingSenderId: "392500802997",
  appId: "1:392500802997:web:83dc78de25f2b691fc55fc",
  measurementId: "G-15KEX0SQ3H",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// ── Second Marriage (separate Firebase project) ────────────────────────────
const smFirebaseConfig = {
  apiKey: "AIzaSyCauUmg5cmK5IPoges8Yb0T-cWw_-H0FAc",
  authDomain: "second-marriage-26.firebaseapp.com",
  projectId: "second-marriage-26",
  storageBucket: "second-marriage-26.firebasestorage.app",
  messagingSenderId: "489621410676",
  appId: "1:489621410676:web:fdd206ac02285e91f15221",
  measurementId: "G-CZ3C7VVKMS",
};

// Second argument 'secondMarriage' is just an internal name — avoids the
// "duplicate app" error if this file is imported twice.
const smApp = initializeApp(smFirebaseConfig, 'secondMarriage');
const smDb = getFirestore(smApp);
const smAuth = getAuth(smApp);

export { db, auth, smDb, smAuth };
